import { useFAQ } from '../../Hooks/useFAQs';
import { usePropertyDetilas } from '../../Hooks/usePropertyDetilas';
import IOVacation from './IOVacation';

const PropertyDetails = () => {
  usePropertyDetilas();
  useFAQ();
  return <IOVacation />;
};
export default PropertyDetails;
